import payoutStatus from '@/domain/core/constant/payoutStatus'

export default payoutStatus

// For backward compatibility if needed
export const PAYOUT_STATUS_LEGACY = {
  PENDING: 'pending',
  PAYED: 'payed' // Note: Old API uses 'payed' spelling
}